import { render, staticRenderFns } from "./Service4Table.vue?vue&type=template&id=61ca1a18&"
import script from "./Service4Table.vue?vue&type=script&lang=js&"
export * from "./Service4Table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports